"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapThemeV2Response = exports.mapThemeResponse = void 0;
const ResourceClient_1 = require("./ResourceClient");
const FontClient_1 = require("./FontClient");
const urls_1 = __importDefault(require("./urls"));
const FileUploadUtils_1 = require("./FileUploadUtils");
const mapThemeResponse = (t) => ({
    id: t.id,
    presentationId: t.presentation_id,
    name: t.name,
    backgroundColor: t.background_color,
    backgroundImage: t.background_image,
    backgroundImagePortrait: t.background_image_portrait,
    backgroundImageFileUpload: t.background_image_file_upload
        ? (0, FileUploadUtils_1.mapFileUploadResponse)(t.background_image_file_upload)
        : null,
    backgroundScale: t.background_scale,
    headingTextColor: t.heading_text_color,
    headingFont: t.heading_font,
    heading2TextColor: t.heading_2_text_color,
    heading2Font: t.heading_2_font,
    bodyTextColor: t.body_text_color,
    bodyFont: t.body_font,
    borderColor: t.border_color,
    resource: (0, ResourceClient_1.mapResourceResponse)(t.resource),
    headingFontNew: t.heading_font_new
        ? (0, FontClient_1.mapFontResponse)(t.heading_font_new)
        : null,
    heading2FontNew: t.heading_2_font_new
        ? (0, FontClient_1.mapFontResponse)(t.heading_2_font_new)
        : null,
    bodyFontNew: t.body_font_new ? (0, FontClient_1.mapFontResponse)(t.body_font_new) : null,
});
exports.mapThemeResponse = mapThemeResponse;
const mapThemeV2Response = (t) => ({
    id: t.id,
    presentationId: t.presentation_id,
    name: t.name,
    backgroundColor: t.background_color,
    backgroundImage: t.background_image,
    backgroundImagePortrait: t.background_image_portrait,
    headingTextColor: t.heading_text_color,
    headingFont: t.heading_font,
    heading2TextColor: t.heading_2_text_color,
    heading2Font: t.heading_2_font,
    bodyTextColor: t.body_text_color,
    bodyFont: t.body_font,
    borderColor: t.border_color,
    headingFontNew: t.heading_font_new
        ? (0, FontClient_1.mapFontResponse)(t.heading_font_new)
        : null,
    heading2FontNew: t.heading_2_font_new
        ? (0, FontClient_1.mapFontResponse)(t.heading_2_font_new)
        : null,
    bodyFontNew: t.body_font_new ? (0, FontClient_1.mapFontResponse)(t.body_font_new) : null,
    backgroundImageFileUpload: t.background_image_file_upload
        ? (0, FileUploadUtils_1.mapFileUploadResponse)(t.background_image_file_upload)
        : null,
    backgroundScale: t.background_scale,
});
exports.mapThemeV2Response = mapThemeV2Response;
class ThemeClient {
    getThemes() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.themes(),
            });
            return data.map(exports.mapThemeResponse);
        });
    }
    updateTheme(id, params) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { theme, background_image_file_uploads, } = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.theme(id),
                body: {
                    presentation_id: params.presentationId,
                    name: params.name,
                    heading_font: params.headingFont,
                    heading_text_color: params.headingTextColor,
                    heading_2_font: params.heading2Font,
                    heading_2_text_color: params.heading2TextColor,
                    body_font: params.bodyFont,
                    body_text_color: params.bodyTextColor,
                    background_color: params.backgroundColor,
                    border_color: params.borderColor,
                    heading_font_new_id: (_a = params.headingFontNew) === null || _a === void 0 ? void 0 : _a.id,
                    heading_2_font_new_id: (_b = params.heading2FontNew) === null || _b === void 0 ? void 0 : _b.id,
                    body_font_new_id: (_c = params.bodyFontNew) === null || _c === void 0 ? void 0 : _c.id,
                    background_image_file_upload: params.backgroundImageFileUpload
                        ? (0, FileUploadUtils_1.mapFileUploadRequest)(params.backgroundImageFileUpload)
                        : null,
                    background_scale: params.backgroundScale,
                },
            });
            return [
                (0, exports.mapThemeResponse)(theme),
                background_image_file_uploads
                    ? (0, FileUploadUtils_1.mapNewFileUploadsResponse)(background_image_file_uploads)
                    : null,
            ];
        });
    }
    createTheme(params) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { theme, background_image_file_uploads, } = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.themes(),
                body: {
                    presentation_id: params.presentationId,
                    name: params.name,
                    heading_font: params.headingFont,
                    heading_text_color: params.headingTextColor,
                    heading_2_font: params.heading2Font,
                    heading_2_text_color: params.heading2TextColor,
                    body_font: params.bodyFont,
                    body_text_color: params.bodyTextColor,
                    background_color: params.backgroundColor,
                    border_color: params.borderColor,
                    heading_font_new_id: (_a = params.headingFontNew) === null || _a === void 0 ? void 0 : _a.id,
                    heading_2_font_new_id: (_b = params.heading2FontNew) === null || _b === void 0 ? void 0 : _b.id,
                    body_font_new_id: (_c = params.bodyFontNew) === null || _c === void 0 ? void 0 : _c.id,
                    background_image_file_upload: params.backgroundImageFileUpload
                        ? (0, FileUploadUtils_1.mapFileUploadRequest)(params.backgroundImageFileUpload)
                        : null,
                    background_scale: params.backgroundScale,
                },
            });
            return [
                (0, exports.mapThemeResponse)(theme),
                background_image_file_uploads
                    ? (0, FileUploadUtils_1.mapNewFileUploadsResponse)(background_image_file_uploads)
                    : null,
            ];
        });
    }
    deleteTheme(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.theme(id),
            });
        });
    }
}
exports.default = ThemeClient;
